import { AccessRightFilterCollectionModel, IAccessRightFilterCollection } from './access-right-filter-collection.model';
import { ICreateChangeBase } from '@fi-shared/models/models';
import { IContentLanguageLabelModel } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { ModuleType } from '@fi-shared/types';
import { ILightWeightObject } from '@fi-shared/models/local-search.model';

export interface ITagModel extends ICreateChangeBase {
    Id: number;
    ParentId?: number;
    Name: string;
    Description?: string;
    Names: IContentLanguageLabelModel[];
    Descriptions?: IContentLanguageLabelModel[];
    ModuleTypes?: ModuleType[];
    ConnectedRoles?: ILightWeightObject[];
    ParentSiteMapsCount?: number;
    UsagesCount?: number;
    AccessRightFilterCollection?: IAccessRightFilterCollection;
    ChildItems?: ITagModel[];
    ModuleTypeNames?: string[];
}

export class TagModel {
    Id = 0;
    ParentId: number = null;
    Name = '';
    Description = '';
    Names: IContentLanguageLabelModel[] = [];
    Descriptions: IContentLanguageLabelModel[] = [];
    ModuleTypes: ModuleType[] = [];
    ModuleTypeNames: string[] = [];
    ConnectedRoles: ILightWeightObject[] = [];
    CreatedByUserId = 0;
    CreatedByUserName = '';
    ChangedByUserId = 0;
    ChangedByUserName = '';
    CreatedOn: string; //ISO 8601 date
    ChangedOn: string; //ISO 8601 date
    AccessRightFilterCollection = new AccessRightFilterCollectionModel();
    ChildItems: TagModel[] = [];
    ParentSiteMapsCount = 0;
    Level = 0;
    IsNew?: boolean;
    UsagesCount = 0;

    constructor(data?: ITagModel) {
        if (data) {
            this.Initialize(data);
        }
    }

    Initialize(tag: ITagModel) {
        this.Id = tag.Id;
        this.ParentId = tag.ParentId;
        this.Name = tag.Name;
        this.Names = tag.Names;
        this.Description = tag.Description;
        this.Descriptions = tag.Descriptions;
        this.ModuleTypes = tag.ModuleTypes;
        this.ConnectedRoles = tag.ConnectedRoles;

        this.CreatedByUserId = tag.CreatedByUserId;
        this.CreatedByUserName = tag.CreatedByUserName;
        this.CreatedOn = tag.CreatedOn;
        this.ChangedByUserId = tag.ChangedByUserId;
        this.ChangedByUserName = tag.ChangedByUserName;
        this.ChangedOn = tag.ChangedOn;
        this.ParentSiteMapsCount = tag.ParentSiteMapsCount;
        this.UsagesCount = tag.UsagesCount;

        if (tag.AccessRightFilterCollection != null) {
            this.AccessRightFilterCollection.InitializeAccessRightFilterCollection(tag.AccessRightFilterCollection);
        }

        if (tag.ChildItems) {
            this.ChildItems = tag.ChildItems.map((item) => {
                return new TagModel().Initialize(item);
            });
        }

        return this;
    }
}
